const STORAGE_KEY = 'getdemo_guideLog';

export const isGuideLogEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('guideLog') === 'true') {
      localStorage.setItem(STORAGE_KEY, 'true');
      return true;
    }
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export type PrintGuideLogOptions = {
  message: string;
  data?: unknown;
  level?: 'debug' | 'warn';
};

export const summarizePathsForLog = (
  paths: {
    xpath: string;
    cssPath: string[];
    textXPath: string | null;
    shadowRoot?: boolean;
    iframe?: boolean;
  }[]
) =>
  paths.map((p, i) => ({
    i,
    iframe: Boolean(p.iframe),
    shadowRoot: Boolean(p.shadowRoot),
    cssTries: p.cssPath?.length ?? 0,
    xpathHead: p.xpath ? p.xpath.slice(0, 120) : '',
    hasTextXPath: Boolean(p.textXPath)
  }));

export const printGuideLog = (options: PrintGuideLogOptions): void => {
  if (!isGuideLogEnabled()) return;
  const level = options.level ?? 'debug';
  const logger = level === 'warn' ? console.warn : console.debug;
  if (options.data !== undefined) {
    logger(options.message, options.data);
  } else {
    logger(options.message);
  }
};
